module.exports = __webpack_public_path__ + "img/87ne.deee89bf.svg";